import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

import uniqid from 'uniqid'
import { Visibility, InsertLink } from '@material-ui/icons';

import './ProjectContainer.css'
import StackIcon from 'tech-stack-icons';

const ProjectContainer = ({ project }) => {

  const [open, setOpen] = useState(false);

  // Open the modal
  const handleOpen = () => {
    setOpen(true);
  };

  // Close the modal
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className='project'>
      <div className='project__content'>
        <h3 className='project__title'>{project.name}</h3>
        <p className='project__description'>{project.description}</p>
        <hr className='project__divider' />
        <img
          src={project.images[0]}
          className='project__image'
          alt='Project preview'
        />
      </div>

      <div className='project__actions'>
        {project && (
          <button
            type="button"
            className='project__view-btn'
            onClick={handleOpen}
            aria-label='View details'
          >
            <Visibility />
          </button>
        )}

        {project && project.domains && project.domains[0] && (
          <a
            href={project.domains[0]}
            className='project__link-btn'
            target="_blank"
            rel="noopener noreferrer"
            aria-label='Visit project'
          >
            <InsertLink />
          </a>
        )}
      </div>

      <div>
        {/* Dialog component */}
        <Dialog open={open} onClose={handleClose} variant="outlined" fullWidth maxWidth='md'>
          <DialogTitle>
            <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600', color: 'var(--clr-fg-alt)', lineHeight: '1.2' }}>Project Details</h3>
          </DialogTitle>
          <DialogContent>
            <div className="modal-header">
              {/* Project Image */}
              <img
                src={project.images[0]}
                className="modal-avatar"
                style={{ borderRadius: '12px', width: '120px', height: '80px' }}
                alt="Project Screenshot"
              />

              {/* Project Name, Company, and Date */}
              <div className="modal-info">
                <h3 className="modal-title">{project.name}</h3>
                <h4 className="modal-subtitle">{project.associatedWith}</h4>
                <p className="modal-dates">{project.from} - {project.to}</p>
                {project.domains && project.domains.length > 0 && (
                  <div style={{ marginTop: '0.5rem' }}>
                    <p style={{ fontSize: '0.9rem', color: 'var(--clr-fg)', margin: '0.25rem 0' }}>🌐 Live Links:</p>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {project.domains.map((domain) => (
                        <li key={uniqid()} style={{ fontSize: '0.85rem', margin: '0.1rem 0' }}>
                          <a 
                            href={domain.startsWith('http') ? domain : `https://${domain}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ 
                              color: 'var(--clr-primary)', 
                              textDecoration: 'none',
                              fontSize: '0.85rem',
                              fontFamily: 'Poppins, sans-serif',
                              transition: 'all 0.3s ease',
                              display: 'inline-block'
                            }}
                            className="modal-link"
                          >
                            🔗 {domain}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {/* Description */}
            <div className="modal-section">
              <h4 className="modal-section-title">Project Overview</h4>
              <p className="modal-description">{project.description}</p>
            </div>


            {/* Stack */}
            <div className="modal-section">
              <h4 className="modal-section-title">Technologies Used</h4>
              <div className="modal-stack">
                {project.stack.map((stack) => (
                  <div key={uniqid()} className="modal-stack-item">
                    <StackIcon name={stack} className="icon-small" /> 
                    <span>{stack}</span>
                  </div>
                ))}
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>

    </div>
  )

}




export default ProjectContainer
